// Governing-difficulty select options (value 0-3), localized via the shared
// form.label.* keys. Used by the recipe create + edit forms.
export const difficulty_options = (t) => ([
	{ value: 0, label: t('form.label.beginner') },
	{ value: 1, label: t('form.label.normal') },
	{ value: 2, label: t('form.label.hard') },
	{ value: 3, label: t('form.label.expert') },
]);
